import { lazy as lazyLoad } from 'react';

import { route } from '../profile/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    CourseHistoryCreate: lazyLoad(async () => {
        const { CourseHistoryCreate } = await import('./EditCourseHistory');

        return { default: CourseHistoryCreate };
    }),
    CourseHistoryEdit: lazyLoad(async () => {
        const { CourseHistoryEdit } = await import('./EditCourseHistory');

        return { default: CourseHistoryEdit };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.user-course-history.title-add',
        page: lazy.CourseHistoryCreate,
        path: route.patterns.individualUser.courseHistory.create,
    },
    {
        documentTitle: 'pages.user-course-history.title-edit',
        page: lazy.CourseHistoryEdit,
        path: route.patterns.individualUser.courseHistory.edit,
    },
];
